module.exports = __webpack_public_path__ + "static/index-cc2bcc74cff2df6fcc9025475b1eb41c.png";